// Content Platform — default service blocks (Phase 1). Reproduces the CURRENT service-page body
// exactly, as content blocks, using only already-ratified sources. NO invented marketing copy, NO
// new business facts: the title is the ratified catalogue name, the intro is the existing seoData
// description, the CTAs/related links are the existing ones (WP-3.3 CTA + WP-3.4 mesh).
//
// Pure data builder, node-importable (consumed by the validator and by the React resolver).

import { findService, servicePath, serviceSeoKey, SERVICE_CATALOG } from '../../navigation/serviceCatalog.js';
import { seo } from '../../seo/seoData.js';
import { BLOCK_TYPES } from '../blocks/types.js';

/**
 * Build the default (factual) block list for a service slug.
 * Mirrors the pre-migration ServicePage: H1 (name) + description + CTAs + related services.
 * @param {string} slug
 * @returns {Array} ordered blocks (empty array for an unknown slug — fail-closed)
 */
export function defaultServiceBlocks(slug) {
  const service = findService(slug);
  if (!service) return [];
  const meta = seo[serviceSeoKey(slug)];

  const blocks = [{ type: BLOCK_TYPES.HERO, title: service.name }];

  if (meta && meta.description) {
    blocks.push({ type: BLOCK_TYPES.INTRO, text: meta.description });
  }

  blocks.push({
    type: BLOCK_TYPES.CTA,
    actions: [
      { label: 'Réserver', to: '/reserver' },
      { label: 'Tous les services', to: '/services' },
    ],
  });

  const siblings = SERVICE_CATALOG
    .filter((s) => s.slug !== slug)
    .map((s) => ({ label: s.name, to: servicePath(s.slug) }));
  if (siblings.length) {
    blocks.push({ type: BLOCK_TYPES.RELATED_CONTENT, heading: 'Autres prestations', links: siblings });
  }

  return blocks;
}
